import React, { Fragment } from 'react'
import { FormTextArea } from '@myxplor/forms'
import { Note } from '@myxplor/ui'

export const WithdrawSessionReportFields = ({ values, errors, onChange, loading }) => (
  <fieldset>
    <legend>Withdraw this Session Report</legend>

    <ul>
      <li>
        Submissions can be withdrawn until <strong>28 days after the start of the week</strong> to
        which the submission relates (or until the end of the financial year, if that occurs
        sooner).
      </li>
    </ul>

    <Note important>
      If you are withdrawing a submission after the 28-day limit, you will need to provide a reason
      for the late change for assessment by the Department of Education and Training.
      <FormTextArea
        name="reasonForLateWithdrawal"
        label="Reason for late withdrawal"
        maxLength={1000}
        rows={2}
        value={values.reasonForLateWithdrawal}
        errors={errors.reasonForLateWithdrawal}
        loading={loading}
        onChange={onChange}
      />
    </Note>
  </fieldset>
)

export const WithdrawSessionReportDone = () => (
  <Fragment>The Session Report has now been withdrawn</Fragment>
)



// WEBPACK FOOTER //
// ./src/session-summaries/details/withdraw-session-report/fields.jsx